import React, { useEffect, useState } from 'react';
import connect from '../../utils/connect';
import { Client } from '@app/types/api';
import { MVC_REFRESH } from '../../constants/config';

export const MvcRefreshContext = React.createContext<{
    hasPermission: boolean;
    isVisible: boolean;
    set: (isVisible: boolean) => void;
}>({
    hasPermission: false,
    isVisible: false,
    set: () => {},
});

const MvcRefreshProvider = ({
    children,
    client,
}: {
    children: React.ReactNode;
    client: Client;
}) => {
    const key = `show-mvc-refresh`;
    const hasMvcRefreshPermission = client.permissions?.includes(MVC_REFRESH);
    const showRefreshInitial =
        localStorage.getItem(key) === '1' && hasMvcRefreshPermission;

    const [show, set] = useState(showRefreshInitial);
    const setShowRefresh = value => {
        set(value);
        localStorage.setItem(key, value ? '1' : '0');
    };

    useEffect(() => {
        const storedValue = localStorage.getItem(key);
        if (hasMvcRefreshPermission && storedValue === null) {
            setShowRefresh(true);
        }
    }, [hasMvcRefreshPermission]);

    return (
        <MvcRefreshContext.Provider
            value={{
                hasPermission: hasMvcRefreshPermission,
                isVisible: show,
                set: setShowRefresh,
            }}
        >
            {children}
        </MvcRefreshContext.Provider>
    );
};

export const useMvcRefresh = () => {
    return React.useContext(MvcRefreshContext);
};

export default connect(['client'])(MvcRefreshProvider);
